import { merge } from 'lodash';
/**
 * TODO document the class
 */
export class CashierAclModel {
  pos_price?: boolean;
  pos_qty?: boolean;
  pos_return?: boolean;
  pos_discount?: boolean;
  pos_discount_percentage?: boolean;
  pos_drop?: boolean;
  pos_2for1?: boolean;
  pos_3for2?: boolean;
  pos_4for3?: boolean;
  pos_menu_dashboard?: boolean;
  pos_menu_reprintpinreceipt?: boolean;
  pos_menu_reprintreceipt?: boolean;
  pos_menu_selectreceipt?: boolean;
  pos_menu_buffer?: boolean;
  pos_menu_withdrawal?: boolean;
  pos_menu_deposit?: boolean;
  pos_menu_opendrawer?: boolean;
  pos_menu_stock_divider?: boolean;
  pos_menu_transitin?: boolean;
  pos_menu_transitout?: boolean;
  pos_menu_eos?: boolean;
  pos_menu_system_divider?: boolean;
  pos_menu_settings?: boolean;
  pos_menu_discountsettings?: boolean;
  pos_menu_reasoneditor?: boolean;
  pos_menu_acl?: boolean;
  pos_menu_sscms?: boolean;
  pos_total_discount?: boolean;
  pos_total_discount_percentage?: boolean;
  pos_unblock_coupons?: boolean;

  constructor(originalValue?: Partial<CashierAclModel>) {
    merge(
      this,
      {
        pos_price: false,
        pos_qty: false,
        pos_return: false,
        pos_discount: false,
        pos_discount_percentage: false,
        pos_drop: false,
        pos_2for1: false,
        pos_3for2: false,
        pos_4for3: false,
        pos_menu_dashboard: false,
        pos_menu_reprintpinreceipt: false,
        pos_menu_reprintreceipt: false,
        pos_menu_selectreceipt: false,
        pos_menu_buffer: false,
        pos_menu_withdrawal: false,
        pos_menu_deposit: false,
        pos_menu_opendrawer: false,
        pos_menu_stock_divider: false,
        pos_menu_transitin: false,
        pos_menu_transitout: false,
        pos_menu_eos: false,
        pos_menu_system_divider: false,
        pos_menu_settings: false,
        pos_menu_discountsettings: false,
        pos_menu_reasoneditor: false,
        pos_menu_acl: false,
        pos_menu_sscms: false,
        pos_total_discount: false,
        pos_total_discount_percentage: false,
        pos_unblock_coupons: false,
      },
      originalValue,
    );
  }
}
